import { Box } from "@mui/material";
import BookingDates from "./booking-dates";
import InsuranceList from "./insurance-selection";
import { useEffect, useState } from "react";
import BookingAddress from "./booking-address";
import BookingSummary from "./booking-summary";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { fetchCart } from "slices/cartReducer";
import { format } from "date-fns";
import { getCartCache, setCartCache } from "utils/cart.util";
import { CART_DELV_TYPE } from "constants/general";

const CartBookingDetails = ({
  setCheckoutDates,
}: {
  setCheckoutDates: any;
}) => {
  const cartCache = getCartCache();
  const [localState, setLocalState] = useState<any>(
    cartCache
      ? cartCache
      : {
          from_date: null,
          to_date: null,
          insurance_id: 0,
          pickup_address_id: 0,
          pickup_listing_address_id: 0,
          delivery_address_id: 0,
        }
  );
  const { cartReducer }: any = useAppSelector((state) => state);
  const dispatch = useAppDispatch();
  const cartDelType = cartReducer?.items?.[0]?.delivery_type ?? 0;

  useEffect(() => {
    setTimeout(() => {
      if (cartCache) {
        setLocalState(cartCache);
        searchWithParams(cartCache, true);
      }
    }, 1000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const searchWithParams = (payload: any, defaultLoad = false) => {
    const params = new URLSearchParams({
      ...(payload.from_date && payload.to_date
        ? {
            start_date: payload.from_date,
            end_date: payload.to_date,
          }
        : {}),
      ...(payload.insurance_id
        ? { insurance_id: payload.insurance_id.toString() }
        : {}),
    });
    setCheckoutDates(
      payload.from_date && payload.to_date
        ? {
            start: payload.from_date,
            end: payload.to_date,
          }
        : { start: null, end: null }
    );
    dispatch(fetchCart({ query: params.toString(), softReload: true }));
  };

  return (
    <Box sx={{ my: "35px" }}>
      <BookingDates
        onChange={(vals: any) => {
          const dData = {
            ...localState,
            from_date: format(vals.start, "yyyy-MM-dd"),
            to_date: format(vals.end, "yyyy-MM-dd"),
          };
          setCheckoutDates({
            start: format(vals.start, "yyyy-MM-dd"),
            end: format(vals.end, "yyyy-MM-dd"),
          });
          setLocalState(dData);
          searchWithParams(dData);
          setCartCache(dData);
        }}
        values={{ start: localState.from_date, end: localState.to_date }}
      />
      <InsuranceList
        selected={localState.insurance_id}
        onChange={(id: number) => {
          const dData = { ...localState, insurance_id: id };
          setLocalState(dData);
          searchWithParams(dData);
          setCartCache(dData);
        }}
      />
      <BookingAddress
        onPickupListingAddress={(id: number) => {
          const dData = { ...localState, pickup_listing_address_id: id };
          setLocalState(dData);
          setCartCache(dData);
        }}
        onAddressChange={(id: number) => {
          const dData = {
            ...localState,
            [cartDelType === CART_DELV_TYPE.PICKUP
              ? "pickup_address_id"
              : "delivery_address_id"]: id,
          };
          setLocalState(dData);
          setCartCache(dData);
        }}
        selectedAddress={
          cartDelType === CART_DELV_TYPE.PICKUP
            ? localState.pickup_address_id
            : localState.delivery_address_id
        }
      />
      <BookingSummary localState={localState} />
    </Box>
  );
};

export default CartBookingDetails;
